module.exports = "/_next/static/media/e957db85e3e252f9ab0f19ede1c560f5.svg";